<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
      <span class="badge badge-danger d-lg-none" v-if="alertCount">{{ alertCount }}</span>
    </button>
    <b-link class="navbar-brand" to="/"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <ul v-if="name" class="navbar-nav ml-auto">
      <li class="nav-item d-none d-sm-flex align-items-center px-2">
        <span style="color:rgba(255,255,255,0.7);font-size:0.9rem;">Welcome, {{ name }}</span>
      </li>
      <li class="nav-item">
        <router-link
          to="/alerts"
          class="nav-link alert-bell"
          :title="alertCount ? alertCount + ' active alert' + (alertCount === 1 ? '' : 's') : 'No active alerts'"
        >
          <i class="fas fa-bell"></i>
          <span v-if="alertCount" class="alert-badge">{{ alertCount }}</span>
        </router-link>
      </li>
      <li class="nav-item">
        <button class="navbar-toggler aside-menu-toggler" type="button" @click="logout">
          <i class="fas fa-power-off"></i>
        </button>
      </li>
    </ul>
  </header>
</template>

<script>
import { ALERT_SUMMARY_QUERY } from '@/constants/graphql'
import { getUser } from '@/lib/auth'

export default {
  name: 'c-header',
  data () {
    return {
      alertSummaries: []
    }
  },
  computed: {
    name () {
      let user = getUser()
      if (user) {
        return user.firstName
      }
      return null
    },
    alertCount () {
      return this.alertSummaries ? this.alertSummaries.length : 0
    }
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    logout (e) {
      e.preventDefault()
      this.$swal.fire({
        toast: false,
        timer: 0,
        timerProgressBar: false,
        showConfirmButton: true,
        title: 'Logout?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.resetSession(this.$apollo.provider.defaultClient)
        }
      })
    }
  },
  apollo: {
    alertSummaries: {
      query: ALERT_SUMMARY_QUERY
    }
  }
}
</script>

<style scoped>
.alert-bell {
  position: relative;
  font-size: 1.1rem;
}
.alert-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #dc3545;
  color: #fff;
  font-size: 0.58rem;
  font-weight: 700;
  min-width: 15px;
  height: 15px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  line-height: 1;
  pointer-events: none;
}
</style>
